import React, { useEffect, useState, useContext} from 'react';

import { DownOutlined, LogoutOutlined, MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined, UserOutlined } from '@ant-design/icons';
import { Anchor, Drawer, Button, MenuProps, Modal } from 'antd';
import emblemLogo from '../../assets/images/logo_emblem.svg';
import cdac_logo from '../../assets/images/svg_img/logo_cdac.svg';
import asaaua_logo from '../../assets/images/logo_asaaua.svg'
import './UserHeader.scss';
import ind_flag from '../Images/ind-flag.png';
import { Header } from 'antd/es/layout/layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, Menu, message } from 'antd';
import { BackendAPI } from '../../axios';
import { UserContext } from "./UserContext";
import axios from 'axios';
import Typography from 'antd/es/typography/Typography';
import { RootState } from '../../store/store';
import { useSelector } from 'react-redux';

const { Link } = Anchor;
interface UserHeaderProps {
  setIsOnClickSlider: React.Dispatch<React.SetStateAction<boolean>>;
}

function UserHeader() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // const { username } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [organizationName, setOrganizationName] = useState('');

  // const [hovered, setHovered] = useState(false);
  const handleLogout = async () => {
    try {
      const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

      if (response.status === 200) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("initialTime");
        localStorage.removeItem("lastSavedTime");
        localStorage.removeItem("remainingTime");
        navigate("/");
      }
    } catch (error) {
    }
  };
  const [isFixed, setIsFixed] = useState(false);
      let refreshToken: null = null;
    const getRefreshToken = async () => {
        try {
            const response = await BackendAPI.get("/user/refresh-token", { withCredentials: true });
            refreshToken = response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    window.location.reload();
                }
            }
        }
    };
     const userfromstore = useSelector((state: RootState) => state.user.user);
    //console.log(userfromstore);
    /*const getUserInfo = async () => {
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
        };
        try {
            const response = await BackendAPI.get('/user/info', header);
            console.log("User info response prod:", response.data.aua_kua_code_prod);
           setUsername(response.data.username);
           setOrganizationName(response.data.organizationName);
        } catch (error) {
            console.error('Error fetching user info:', error);
            if (axios.isAxiosError(error)) {
                if (error.request.status == 401) {
                    backToHome();
                }
            }
        }
    };*/

        const backToHome = async () => {
        try {
            const response = await BackendAPI.post("/user/logout", {}, { withCredentials: true });

            if (response.status === 200) {
                localStorage.removeItem("authToken");
                navigate("/");
            }
        } catch (error) {
        }
    };
  useEffect(() => {
    const executeFunctions = async () => {
      await getRefreshToken();
     // await getUserInfo();
    };
    executeFunctions();
  }, []);
  useEffect(() => {
    console.log("username=> ", username);
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsFixed(scrollTop > 100); // adjust the threshold
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);

  }, []);

  const handleFaqClick = (id_name: string) => {
    navigate(`/#${id_name}`); // navigate to homepage first

    // Scroll after short delay to ensure the page is rendered
    setTimeout(() => {
      const faqSection = document.getElementById(`${id_name}`);
      if (faqSection) {
        faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  };
  const handleCollapse = () => {
    // setIsOnClickSlider(prev => !prev);
    setCollapsed(prev => !prev);
  };
  return (
    <>
      <div
  style={{
    position: "sticky",
    top: 0,
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
    zIndex: 1000,
    background: "#1515b4",
  }}
>
  <div
    className="user-container-fluid"
    style={{
      width: "100%",
    }}
  >
    <div className="header" style={{ height: 50 }}>

      {/* Logo */}
      <div
        className="logo"
        style={{
          cursor: "pointer",
          userSelect: "none",

          // Added spacing around logo
          paddingLeft: "8px",
          paddingRight: "15px",
        }}
      >
        <img
          src={asaaua_logo}
          alt="asa-aua logo"
          className="logo-image"
        />
      </div>

      {/* Profile section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",

          // Removed background and box styling
          padding: "3px 6px",
          borderRadius: "6px",
          background: "transparent",
        }}
      >

        <div
          style={{
            marginInline: "16px",
          }}
        >
          <h4
            style={{
              fontWeight: "700",
              margin: "6px",
              color: "white",
              fontSize: "14px",
            }}
          >
            {organizationName}
          </h4>
        </div>

        <div className="dropdown">

          <Button
            className="user-button"
            style={{
              fontWeight: "700",
              background: "transparent", // removed profile box background
              color: "white",
              border: "none",            // remove button border
              boxShadow: "none",         // remove button shadow
            }}
          >
            <UserOutlined
              style={{
                marginRight: 8,
              }}
            />

            {userfromstore?.username + ":"}
            {userfromstore?.organizationName}

            <DownOutlined />
          </Button>

          <div className="dropdown-content">

            <div
              className="menu-item"
              onClick={handleLogout}
            >
              Logout
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>
    </>
  );
}

export default UserHeader;